import JobPeriod from '../../../views/Personnel/Report/JobPeriod.report.view';

export default JobPeriod;
